module.exports = __webpack_public_path__ + "img/category-casino-hover.eda26c53.png";